import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import type { IIconInterface } from "./icon.interface";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export const isFilled = (iconProps: IIconInterface): boolean =>
  iconProps.variant === ("filled" as IIconInterface["variant"]);

export const isThin = (iconProps: IIconInterface): boolean =>
  iconProps.variant === ("thin" as IIconInterface["variant"]);

export const overrideStroke = (iconProps: IIconInterface): string =>
  isFilled(iconProps) ? "white" : "currentColor";
